// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataExplorer .searchButton {
  height: 30px;
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  flex: 1 1;
  border: none;
  border-radius: 0px;
  color: #eee;
  padding: 0px 30px;
  font-weight: 500;
  cursor: pointer;
}

.dataExplorer .searchButton:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.dataExplorer .downloadButton {
  height: 30px;
  background-color: transparent;
  border: 1px solid gray;
  border-radius: 0;
  cursor: pointer;
}

.dataExplorer .downloadButton:hover {
  background-color: #4b96ee;
  border-color: #4b96ee;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DataExplorer/DataExplorer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ;;;;GAIC;EACD,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".dataExplorer .searchButton {\n  height: 30px;\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  flex: 1;\n  border: none;\n  border-radius: 0px;\n  color: #eee;\n  padding: 0px 30px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.dataExplorer .searchButton:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.dataExplorer .downloadButton {\n  height: 30px;\n  background-color: transparent;\n  border: 1px solid gray;\n  border-radius: 0;\n  cursor: pointer;\n}\n\n.dataExplorer .downloadButton:hover {\n  background-color: #4b96ee;\n  border-color: #4b96ee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
